import React, { useState } from 'react';
import Tooltip from 'components/styleguide/tooltip/Tooltip';

const styles = require('./EorTooltip.module.scss');
const iconInfo = require('svg/icons-lj-styleguide-2025/info.svg');

let triggerIdCounter = 0;

export default function EorTooltip() {
  const [triggerId] = useState(() => `eor-tooltip-trigger-${++triggerIdCounter}`);

  const handleTryEor = () => {
    document.dispatchEvent(new Event('eor-calculator:open'));
  };

  return (
    <>
      <button
        id={triggerId}
        type="button"
        className={styles.trigger}
        aria-label="More info about Employer of Record"
      >
        <img src={iconInfo} alt="" width="18" height="18" />
      </button>
      <Tooltip
        targetId={triggerId}
        role="dialog"
        variant="rich"
        trapFocus
        title="Hiring without legal entity?"
        button={{ context: 'talent', label: 'Try EOR', onClick: handleTryEor }}
      >
        Calculate the true cost of hiring talent in Portugal with EOR.
      </Tooltip>
    </>
  );
}
